import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { loadAppConfig } from './config/appConfig';

// Suprimir el error conocido de ResizeObserver
// Este error ocurre cuando Material-UI y Recharts usan ResizeObserver simultáneamente
// No es crítico y no afecta la funcionalidad de la aplicación
const originalError = console.error;
console.error = (...args: any[]) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return;
  }
  originalError.call(console, ...args);
};

// También manejar errores no capturados del mismo tipo
window.addEventListener('error', (event) => {
  if (
    event.message &&
    event.message.includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
});

// Cargar configuración antes de renderizar la aplicación
loadAppConfig().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}).catch((error) => {
  console.error('Error al cargar la configuración:', error);
  // Renderizar de todas formas con valores por defecto
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
});